/**
 * Sometimes its import causes:\
 * `Cannot find module 'repoV2/constants/environment' or its corresponding type declarations.`\
 * fix that by providing absolute path(using "../" or "./") instead of relative path (eg: "repoV2/constants/environment") of the missing module
 */
export const NODE_ENV_IS_NOT_PRODUCTION: boolean =
    process.env.NODE_ENV !== "production";
